const DEBUGGING: boolean = process.env.NODE_ENV === 'development'

import { BaseObject, MongoObject } from './_baseClasses'
import { Moment } from './Moment';
import { acquiredType } from './MomentOwned';
import * as telegram from "./telegram"
import * as utils from "./utils"
import { Account } from './Account';

export type sortOrderTypes = 'FMV_DESC' | 'FMV_ASC' | 'TransferDate_DESC' | 'TransferDate_ASC'

export class MomentTransferred extends Moment {
  public acquiredDate: Date = null
  public acquiredType: acquiredType = null
  public senderAddress: string = null
  public senderUsername: string = null
  public senderImageURL: string = null
  public receiverAddress: string = null
  public receiverUsername: string = null
  public receiverImageURL: string = null

  // complex, class-based fields (require to be hydrated after loading from external sources like mongo or elastic)

  constructor(po?: object) {
    super(po)
    if (po) this.injectPlainObject(po)

    this.hydrate()
  }

  protected hydrate(): void {
    super.hydrate()
    if (typeof this.acquiredDate === 'string') this.acquiredDate = new Date(this.acquiredDate)
  }

  public isSafe(): boolean {
    if (!super.isSafe()) return false
    return true
  }

}

(async () => {
})();
